<template>
  <section>
    <div class="tip" style="margin:25px 0 0 20px">* 项目基本资料</div>
    <ul class="project-info-list">
      <li>
        <label>申请印章：</label>
        <div class="info-item">{{ form.sealName }}</div>
      </li>
      <li>
        <label>申请内容：</label>
        <div class="info-item">{{ getSealType(form) }}</div>
      </li>
      <li>
        <label>申请单位：</label>
        <div class="info-item">{{ userData.department.split('/')[0] }}</div>
      </li>
      <li>
        <label>申请人：</label>
        <div class="info-item">{{ userData.name }}</div>
      </li>
      <li>
        <label>联系方式：</label>
        <div class="info-item">{{ userData.mobile }}</div>
      </li>
      <li v-if="form.applyType == 0">
        <label>申请时间：</label>
        <div class="info-item">{{ form.useTime }}</div>
      </li>
      <li v-if="form.applyType == 0 && form.type == 1">
        <label>归还时间：</label>
        <div class="info-item">{{ form.returnTime }}</div>
      </li>
      <li>
        <label>申请事由：</label>
        <div class="info-item">{{ form.remark }}</div>
      </li>
    </ul>

  </section>
</template>
<script>
  export default {
    props: ['form', 'userData', 'sealArr'],
    data() {
      return {
        // form: {}
      }
    },
    mounted() {
      // this.form = this.formByFather
    },
    methods: {
      getSealType(form) {
        if (form.applyType == 0) {
          if (form.type == 0) {
            return "使用印章"
          } else {
            return "外带印章"
          }
        } else {
          if (form.type == 0) {
            return "刻制印章"
          } else {
            return "销毁印章"
          }
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/user/projectinfo/seal.vue